import CalendarInput from 'components/CalendarInput/CalendarInput'
import { CheckBox } from 'components/CheckBox/CheckBox'
import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import { currencies } from 'pages/Companies/AddCompany'
import { toast } from 'react-toastify'
import { Button, Flex, ThinSeparator } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { IAddOperationPlanTab, IOperationPlanState } from 'types/operationPlans.interface'

export const Targets = ({ setStep, setState, state }: IAddOperationPlanTab) => {
    const handleSelect = (v: ISelectValue, n: string) => {
        setState((prev: IOperationPlanState) => ({ ...prev, [n]: v }))
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type } = e.target
        setState((prev: IOperationPlanState) => ({ ...prev, [name]: type === 'number' ? Number(value) : value }))
    }

    const handleCheckbox = () => {
        setState((prev: IOperationPlanState) => ({ ...prev, autoPauseOnL3Plus: !prev.autoPauseOnL3Plus }))
    }

    const handleNext = () => {
        if (!state.targetUnit?.value) {
            toast.warn('Target unit is required');
            return
        }
        if (!state.targetValue) {
            toast.warn('Target value is required');
            return
        }
        if (!state.targetCurrencyCode?.value && !!state.targetBudgetCost) {
            toast.warn('Currency is required when target budget is provided');
            return
        }
        setStep(4)


    }
    const handleBack = () => setStep(2)

    // Critical, High, Medium, Low
    const priorityOptions = [{ label: 'Low', value: 1 }, { label: 'Medium', value: 2 }, { label: 'High', value: 3 }, { label: 'Critical', value: 4 }]

    return <>
        <Container>
            <ContainerHeader>
                <TitleText>Targets</TitleText>
            </ContainerHeader>
            <ContainerContent>
                <Flex gap='1rem' mb='16'>
                    <HonestSelectInput options={priorityOptions} onChange={handleSelect} labelText='Priority' name='priority' defaultValue={state.priority?.value} />
                    <HonestSelectAsyncInput
                        link='units'
                        name='targetUnit'
                        labelText='Target unit'
                        placeholder='g, kg, ml...'
                        defaultValue={state?.targetUnit?.label}
                        onChange={handleSelect}
                        parserFunction={(data: any) => data.map((i: any) => ({ label: i.name, value: i.id }))}
                        required
                        invalid={!state.targetUnit?.value}
                    />
                </Flex>
                <Input labelText='Target value' name='targetValue' placeholder='Enter target value' value={state.targetValue} type='number' onChange={handleChange} required invalid={!state.targetValue} />
                <ThinSeparator />
                <TitleText weight='bold' >Budget (optional)</TitleText>
                <Flex gap='1rem' mt='16' >
                    <Input labelText='Budget amount' name='targetBudgetCost' placeholder='Enter budget amount' value={state.targetBudgetCost} type='number' onChange={handleChange} />
                    <HonestSelectAsyncInput onChange={handleSelect} fixedList={currencies} labelText='Currency' name='targetCurrencyCode' defaultValue={state.targetCurrencyCode?.label} required={!!state.targetBudgetCost} invalid={!state.targetCurrencyCode?.value && !!state.targetBudgetCost} />
                </Flex>
                <Flex gap='1rem' mt='16' mb='16' >
                    <CalendarInput labelText='Due date' width='100%' name='dueAt' defaultValue={state.dueAt} minDate={new Date()} onChange={() => setState((prev: IOperationPlanState) => ({ ...prev, dueAt: new Date() }))} />
                    <HonestSelectInput options={boardVisibilityOptions} name='boardVisibility' onChange={handleSelect} labelText='Board visibility' width='100%' defaultValue={state.boardVisibility?.value} />
                </Flex>
                <Input height='100px' type='textarea' labelText='Objective' name='objective' placeholder='Enter objective' value={state.objective} onChange={handleChange} />
                <CheckBox state={!!state.autoPauseOnL3Plus} title='Auto-pause on L3+' square onClick={handleCheckbox} />

            </ContainerContent>

        </Container>
        <Flex gap='1rem' mt='32' justend>
            <Button onClick={handleBack}>Back</Button>
            <Button orange onClick={handleNext} >Next</Button>
        </Flex>
    </>
}

const boardVisibilityOptions = [{ label: 'Internal (team)', value: 1 }, { label: 'Ops directors', value: 2 }, { label: 'Executive', value: 3 }]